import { apiGet, throwApiError } from "../utils";

export const searchLeagues = async (search = "") => {
  const response = await apiGet("/league", { search });
  const data = await response.json();

  throwApiError(data);

  if (Array.isArray(data)) {
    return data;
  }

  if (data.items && Array.isArray(data.items)) {
    return data.items;
  }

  return [];
};

export const searchTeams = async (search = "") => {
  const response = await apiGet("/teams", { search });
  const data = await response.json();

  throwApiError(data);

  if (Array.isArray(data)) {
    return data;
  }

  if (data.items && Array.isArray(data.items)) {
    return data.items;
  }

  return [];
};
